import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Button,
  Confirm,
  Form,
  Grid,
  Icon,
  Image,
  Input,
  Modal,
} from "semantic-ui-react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { uid } from "uid";
import { addSkills } from "../../store/actions/athleteActions";
import { BsFillPatchCheckFill } from "react-icons/bs";
import { imageRegex, ytPlaylistRegex } from "../../utils/regex";
const AddSkills = (props) => {
  const [thumbnail, setThumbnail] = useState(null);
  const [thumbnailUrl, setThumbnailUrl] = useState(null);
  const [error, setError] = useState(false);
  const [warning, setWarning] = useState(false);
  const [title, setTitle] = useState(null);
  const [url, setUrl] = useState(null);
  const dispatch = useDispatch();
  const handleSubmit = () => {
    if (thumbnail && title && url) {
      const data = { id: uid(8), title, playlistUrl: url, thumbnail };
      if (!error) {
        dispatch(addSkills(data));
        setThumbnail(null);
        setThumbnailUrl(null);
        setError(false);
        setWarning(false);
        setTitle(null);
        setUrl(null);
      }
    } else {
      setWarning("All Fields Are Required");
    }
  };
  const handleThumbnail = (e) => {
    if (imageRegex.test(e.target.files[0].name)) {
      setThumbnailUrl(URL.createObjectURL(e.target.files[0]));
      setThumbnail(e.target.files[0]);
    } else {
      setError("It should be image");
    }
  };

  const handleTitleChange = (data) => {
    setTitle(data);
  };
  const handleUrlChange = (data) => {
    if (ytPlaylistRegex.test(data)) {
      setUrl(data);
      setError(false);
    } else {
      setError("It should be youtube playlist");
    }
  };
  props.progress === 100 &&
    setTimeout(() => {
      props.onClose();
      setError(false);
      setThumbnail(null);
      setThumbnailUrl(null);
      setTitle(null);
      setUrl(null);
    }, 2000);
  return (
    <Modal size="tiny" onClose={props.onClose} open={props.open}>
      <Modal.Content scrolling>
        <div className="AdminTopButtonsProgressContainer">
          <div className="AdminTopButtonsContainer d-custom">
            <Button
              floated="left"
              circular
              icon="close"
              onClick={() => {
                props.onClose();
                setThumbnail(null);
                setThumbnailUrl(null);
                setError(false);
                setWarning(false);
                setTitle(null);
                setUrl(null);
              }}
            />
            <div className="d-CustomInnderdiv">
              {props.progress === 100 && (
                <span className="successPlayerToWatch">
                  Added <BsFillPatchCheckFill size={16} />
                </span>
              )}
              {!error && !props.saving && (
                <Button
                  floated="right"
                  positive
                  name="saveButton"
                  content="Save"
                  labelPosition="right"
                  icon="checkmark"
                  onClick={handleSubmit}
                />
              )}
              {error && (
                <Button
                  floated="right"
                  disabled
                  name="saveButton"
                  content="Save"
                  labelPosition="right"
                  icon="checkmark"
                  onClick={handleSubmit}
                />
              )}
              {props.saving && (
                <Button
                  floated="right"
                  loading
                  name="saveButton"
                  content="Save"
                  labelPosition="right"
                  icon="checkmark"
                />
              )}
            </div>
          </div>
        </div>
        <div className="head-data">
          <h3>Add Skills</h3>
          {error && <p style={{ color: "#800000" }}>{error}</p>}
          {warning && <p style={{ color: "#FF6600" }}>{warning}</p>}
        </div>
        <ul className="full">
          <li>
            <div className="full-skills full">
              <div className="one-skill">
                <label for="thumbnail">
                  <Icon name="upload" />
                </label>
                {thumbnailUrl && <Image src={thumbnailUrl} />}
                {!thumbnailUrl && (
                  <Image
                    src={
                      "https://via.placeholder.com/640x380.png/e6e6e6/000000?Text=640x380"
                    }
                  />
                )}
                <Input
                  type="file"
                  id="thumbnail"
                  style={{ display: "none" }}
                  placeholder="Select image"
                  onChange={handleThumbnail}
                />
              </div>
              <div className="two-skill">
                <Grid divided="vertically">
                  <Grid.Row stackable="true" columns={2}>
                    <Grid.Column mobile={16} tablet={16} computer={16}>
                      <Form.Field>
                        <label>Title *</label>
                        <Input
                          placeholder="Title"
                          onChange={(e) => handleTitleChange(e.target.value)}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={16}>
                      <Form.Field>
                        <label>Youtube URL *</label>
                        <Input
                          placeholder="Youtube URL"
                          onChange={(e) => handleUrlChange(e.target.value)}
                        />
                      </Form.Field>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </div>
            </div>
          </li>
        </ul>
        <Confirm
          // open={this.state.confirmOpen}
          content="You have unsaved changes.  Are you sure you want to exit?"
          // onCancel={this.confirmCloseCancel}
          // onConfirm={this.confirmClose}
        />
      </Modal.Content>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    sucess: state.athlete.skillAdded,
    saving: state.athlete.skillAdding,
    progress: state.athlete.skillAddProgress,
    file: state.athlete.skillAddProgressType,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "skillsPlaylists",
    },
  ])
)(AddSkills);
